module.exports = __webpack_public_path__ + "media/images/icon_register-979ce84ccca3225cd58f5090dad34116.png";